module.exports = "<div [formGroup]=\"parent\">\n\n  <section>\n    <mat-checkbox [formControlName]=\"attribute.value\">{{attribute.label}}</mat-checkbox>\n    <mat-error *ngIf=\"invalid.required\">{{attribute.label}} is required</mat-error>\n  </section>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/checkbox/checkbox.component.html
// module id = ./src/app/shared/checkbox/checkbox.component.html
// module chunks = main